export enum ToastType {
    info,
    error,
    warning
}